import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Search, FileCheck, Shield, Scale, Database, BookOpen, Mail, Menu, X } from 'lucide-react';

const MobileMenu = ({ navItems }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
    const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);

  const handleDropdownClick = (label) => {
    setOpenDropdown(openDropdown === label ? null : label);
  };

  return (
    <div className="md:hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 rounded-lg hover:bg-gray-100"
      >
        {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {isOpen && (
        <div className="absolute top-16 left-0 right-0 bg-white border-b border-gray-200 shadow-lg">
          <div className="px-4 py-2 space-y-2">
            {navItems.map((item) => (
              <div key={item.label}>
                {item.dropdown ? (
                  <div>
                    <button
                      onClick={() => handleDropdownClick(item.label)}
                      className="w-full flex items-center justify-between px-4 py-2 text-base font-medium text-gray-600 hover:text-blue-500"
                    >
                      <span>{item.label}</span>
                      <ChevronDown className={`w-4 h-4 transition-transform ${
                        openDropdown === item.label ? 'rotate-180' : ''
                      }`} />
                    </button>
                    {openDropdown === item.label && (
                      <div className="pl-4 space-y-1">
                        {item.dropdown.map((dropdownItem, i) => {
                           if (dropdownItem.items && Array.isArray(dropdownItem.items)) {
                            return (
                              <div key={dropdownItem.title || `group-${i}`} className="px-4 py-2">
                                {dropdownItem.title && (
                                  <div className="text-xs font-semibold text-gray-500 uppercase mb-1">
                                    {dropdownItem.title}
                                  </div>
                                )}
                                {dropdownItem.items.map((subItem) => {
                                  const Icon = subItem.icon;
                                  return (
                                    <Link
                                      key={subItem.id}
                                      to={subItem.href}
                                      onClick={() => {
                                        if (item.label === 'Solutions') setIsSolutionsOpen(false);
                                        if (item.label === 'Resources') setIsResourcesOpen(false);
                                        setIsOpen(false);
                                      }}
                                      className={`flex items-center gap-3 px-4 py-2 text-sm transition-colors hover:bg-gray-50 cursor-pointer ${
                                        location.pathname === subItem.href
                                          ? 'text-blue-500'
                                          : 'text-gray-600'
                                      }`}
                                    >
                                      <div className="p-2 bg-[#EBF3FF] rounded-lg">
                                        <Icon className="w-5 h-5 text-[#4B83F2]" />
                                      </div>
                                      <span>{subItem.label}</span>
                                    </Link>
                                  );
                                })}
                              </div>
                            );
                          }
                          const Icon = dropdownItem.icon;
                          return (
                            <Link
                              key={dropdownItem.id}
                              to={dropdownItem.href}
                              onClick={() => {
                                setIsOpen(false);
                                setOpenDropdown(null);
                              }}
                              className={`flex items-center gap-3 px-4 py-2 text-sm transition-colors hover:bg-gray-50 ${
                                location.pathname === dropdownItem.href
                                  ? 'text-blue-500'
                                  : 'text-gray-600'
                              }`}
                            >
                              <div className="p-2 bg-[#EBF3FF] rounded-lg">
                                <Icon className="w-5 h-5 text-[#4B83F2]" />
                              </div>
                              <span>{dropdownItem.label}</span>
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={item.href}
                    onClick={() => setIsOpen(false)}
                    className={`block px-4 py-2 text-base font-medium transition-colors hover:text-blue-500 ${
                      location.pathname === item.href
                        ? 'text-blue-500'
                        : 'text-gray-600'
                    }`}
                  >
                    {item.label}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileMenu; 